import { render, staticRenderFns } from "./NpsmEditAbout.vue?vue&type=template&id=65bc8b90&scoped=true&"
import script from "./NpsmEditAbout.vue?vue&type=script&lang=js&"
export * from "./NpsmEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc8b90",
  null
  
)

export default component.exports